<template>
  <div
    class="d-flex align-items-center bg-body-secondary m-3 background-box-shadow"
  >
    <RulePropertyRemove
      class="ms-3"
      @click.native="removeValue(aggregateValue.rule.reference)"
    />
    <div>
      <div class="ms-3 p-1 fw-bold">
        {{ trans_choice('core.points', 2) }}:
      </div>
      <input
        v-model="count"
        class="form-control input-width mx-3 mb-2"
        type="number"
        min="1"
        @change="changePropertyValue(ruleProperty.value)"
      >
    </div>
    <RuleTypeShow
      class="flex-grow-1"
      :rule="aggregateValue.rule"
      :display-delete="false"
    />
  </div>
</template>

<script>
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import { RULE_PROPERTY } from '@/constants'
export default {
  name: 'RuleAggregateValue',
  mixins: [ruleMixin],
  props: {
    aggregateValue: {
      required: true,
      type: Object,
    },
    parentReference: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      ruleProperty: RULE_PROPERTY,
      count: 1,
    }
  },
  computed: {
    childParentruleReference () {
      return this.parentReference + this.aggregateValue.rule.reference
    },
  },
  mounted () {
    this.count = this.aggregateValue.value
  },
  methods: {
    removeValue () {
      this.$root.$emit('RemoveRule', [this.aggregateValue.rule.reference])
    },
    changePropertyValue (rulePropertyEnum) {
      this.rulePropertyValueChange(this.childParentruleReference, rulePropertyEnum, Number(this.count))
    },
  },
}
</script>

<style lang="scss" scoped>
.input-width {
  min-width: 60px;
  max-width: 75px;
}
.background-box-shadow {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>
